module.exports = ['He/Him/His', 'She/Her/Hers', 'They/Them/Theirs'];
